import axios, { AxiosRequestConfig } from "axios";
import { MISBILLED_TRADES_API } from "./constants";
import { startOfDay, timeNow } from "../utils";

export const getMisbilledTrades = (
  startDate: string,
  endDate: string,
  config: AxiosRequestConfig
) => {
  return axios.get(
    `${MISBILLED_TRADES_API}?startDateTime=${startOfDay}&endDateTime=${timeNow}`,
    config
  );
};
